import { ChakraProvider, ChakraProviderProps as ChakraThemeProviderProps } from '@chakra-ui/react';
import { bool } from 'prop-types';
import React from 'react';

import { InferPropTypes } from '../types';

import Fonts from './Fonts/Fonts';
import EmojiStyles from './Libraries/emoji-mart/Emojis';
import ResetCSS from './ResetCSS';
import THEME from './theme';

const propTypes = {
  resetCSS: bool
};

const defaultProps = {
  resetCSS: true
};

export type ThemeProviderProps = ChakraThemeProviderProps & InferPropTypes<typeof propTypes, typeof defaultProps>;

const ThemeProvider = (props: ThemeProviderProps): React.ReactElement => {
  const { children, resetCSS, ...rest } = props;
  return (
    <ChakraProvider resetCSS={false} {...rest} theme={THEME}>
      {resetCSS && <ResetCSS />}
      <Fonts />
      <EmojiStyles />
      {children}
    </ChakraProvider>
  );
};

ThemeProvider.propTypes = propTypes;
ThemeProvider.defaultProps = defaultProps;

export default ThemeProvider;
